import React, { useState, useEffect, useRef, useCallback } from "react";

import Card from "../Card/Card";
import CardList from "../CardList/CardList";

import { Medium, Small } from "../../styles/typography/typography";
import { colors as c } from "../../styles/variables.js"

import {
    ContainerSt,
    HeaderSt,
    ContentSt,
    ContentDSt,
    DescriptionContainerSt,
    ContentDCLSt
} from './style.js';
import { LinkSt } from "../Carousel/style";

import i18n from "i18next";

const Grid = ({ cards, type, page, tile, chooseCard, title, _getallchooseCard, past, widthCard, link, description }) => {
    const [closeAllCardsDiscription, setCloseAllCardsDiscription] = useState(false);

    const timers = useRef([]);
    useEffect(() => () => { timers.current.forEach(clearTimeout) }, []);

    // при открытии второго описания закрываем первое
    const _closeAllCardsDiscription = useCallback(() => {
        setCloseAllCardsDiscription(true);
        timers.current.push(setTimeout(() => {
            setCloseAllCardsDiscription(false);
        }, 50));
    }, []);

    const now = new Date();
    let orderCards = 0;
    let cardsCount = 0;

    const AllCards = cards.map((item, i) => {
        if (type === "events") { // Если карточка относится к типу "events", то она обрабытывается следующим образом
            if (page === "favorites") {
                cardsCount++;
                return (
                    tile ? <Card {...item} key={item.slug} type={type} zIndexCard={cards.length - i} discriptionOpenLeft={false} page={page} chooseCard={chooseCard} _getallchooseCard={_getallchooseCard} /> : <CardList {...item} key={item.slug} type={type} page={page} />
                )
            }
            else {
                if (String(item.date_start).substr(0, 4) === String(title)) { // Карта выводится на экран если год указанный поле "date" совпадает с годом в заголовке
                    if (now.getFullYear() === title) { // если тякущий год, то проверяется еще не закончилось ли уже событие
                        if (!past && (now.getMonth() + 1 < Number(item.date_end.substr(5, 2)) || (now.getMonth() + 1 === Number(item.date_end.substr(5, 2)) && now.getDate() < Number(item.date_end.substr(8, 2))))) {
                            cardsCount++;
                            return (
                                tile ? <Card {...item} key={item.slug} type={type} zIndexCard={cards.length - i} discriptionOpenLeft={false} chooseCard={chooseCard} _getallchooseCard={_getallchooseCard} /> : <CardList {...item} key={item.slug} type={type} />
                            )
                        }
                        else if (past && (now.getMonth() + 1 > Number(item.date_end.substr(5, 2)) || (now.getMonth() + 1 === Number(item.date_end.substr(5, 2)) && now.getDate() > Number(item.date_end.substr(8, 2))))) {
                            cardsCount++;
                            return (
                                tile ? <Card {...item} key={item.slug} type={type} zIndexCard={cards.length - i} discriptionOpenLeft={false} chooseCard={chooseCard} _getallchooseCard={_getallchooseCard} /> : <CardList {...item} key={item.slug} type={type} />
                            )
                        }
                    }
                    else {
                        cardsCount++;
                        return (
                            tile ? <Card {...item} key={item.slug} type={type} zIndexCard={cards.length - i} discriptionOpenLeft={false} chooseCard={chooseCard} _getallchooseCard={_getallchooseCard} /> : <CardList {...item} key={item.slug} type={type} />
                        )
                    }
                }
            }
        }
        else { // Если карточка не относится к типу "events"
            orderCards++;
            if (widthCard ? orderCards % 3 === 0 : orderCards % 5 === 0) {
                cardsCount++;
                return (
                    tile
                        ? <Card {...item} key={item.title} type={type} zIndexCard={cards.length - i} discriptionOpenLeft={true} chooseCard={chooseCard} _closeAllCardsDiscription={_closeAllCardsDiscription} closeAllCardsDiscription={closeAllCardsDiscription} page={page} widthCard={widthCard} _getallchooseCard={_getallchooseCard} />
                        : <CardList {...item} key={item.title} type={type} page={page} widthCard={widthCard} chooseCard={chooseCard} _getallchooseCard={_getallchooseCard} />
                )
            }
            else {
                cardsCount++;
                return (
                    tile
                        ? <Card {...item} key={item.title} type={type} zIndexCard={cards.length - i} discriptionOpenLeft={false} chooseCard={chooseCard} _closeAllCardsDiscription={_closeAllCardsDiscription} closeAllCardsDiscription={closeAllCardsDiscription} page={page} widthCard={widthCard} _getallchooseCard={_getallchooseCard} />
                        : <CardList {...item} key={item.title} type={type} page={page} widthCard={widthCard} chooseCard={chooseCard} _getallchooseCard={_getallchooseCard} />
                )
            }
        }
        return undefined;
    })

    const definedCards = AllCards.filter((item) => item !== undefined);

    return (
        <>
            {cardsCount > 0 && <ContainerSt>
                {title && <HeaderSt page={page === "collections"}>
                    {title}
                    {link && <LinkSt to={link}><Small uppercase bold color={c.blue}>{i18n.t(`collections.go_to_collection`)}</Small></LinkSt>}
                </HeaderSt>}
                <DescriptionContainerSt>
                    <Medium>{description}</Medium>
                </DescriptionContainerSt>
                <ContentSt>
                    {(tile || window.innerWidth < 768)
                        ? <ContentDSt>{AllCards}</ContentDSt>
                        : <ContentDCLSt>
                            <div>{definedCards.filter((item, i) => i % 2 === 0)}</div>
                            <div>{definedCards.filter((item, i) => i % 2 !== 0)}</div>
                        </ContentDCLSt>}
                </ContentSt>
            </ContainerSt>}
        </>
    );
};

export default Grid;
